import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d7d61cd4&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=d7d61cd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d61cd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7d61cd4')) {
      api.createRecord('d7d61cd4', component.options)
    } else {
      api.reload('d7d61cd4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d7d61cd4&scoped=true&", function () {
      api.rerender('d7d61cd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/viewsBlack/social/club/index.vue"
export default component.exports